import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router";

import { SiteLayout } from "@/layouts/SiteLayout";
import { pathNames } from "./paths";

const HomePage = lazy(() => import("@/pages/home"));
const ProductDetailPage = lazy(() => import("@/pages/productDetail"));
const AboutPage = lazy(() => import("@/pages/about"));
const FaqPage = lazy(() => import("@/pages/faq"));
const ContactPage = lazy(() => import("@/pages/contactPage"));
const PolicyPage = lazy(() => import("@/pages/privacyPolicy"));
const RefundPage = lazy(() => import("@/pages/refund"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export const appRoutes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: pathNames.home,
        element: <HomePage />,
        handle: { title: "首页" },
      },
      {
        path: "/products/:slug",
        element: <ProductDetailPage />,
        handle: { title: "产品详情" },
      },
      {
        path: pathNames.about,
        element: <AboutPage />,
        handle: { title: "关于我们" },
      },
      {
        path: pathNames.faq,
        element: <FaqPage />,
        handle: { title: "常见问题" },
      },
      {
        path: pathNames.contact,
        element: <ContactPage />,
        handle: { title: "联系我们" },
      },
      {
        path: pathNames.privacy,
        element: <PolicyPage />,
        handle: { title: "隐私政策" },
      },
      {
        path: pathNames.refund,
        element: <RefundPage />,
        handle: { title: "退款政策" },
      },
    ],
  },
  {
    path: pathNames.notFound,
    element: <NotFoundPage />,
    handle: { title: "页面未找到" },
  },
  { path: "*", element: <Navigate to={pathNames.notFound} replace /> },
];
